// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lVwfU","question":"styles_question__21RWJ","inputVisibleButton":"styles_inputVisibleButton__2E2nZ","note":"styles_note__2Ohkp"};